module.exports = __webpack_public_path__ + "img/newicon2on.06a17418.svg";